import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../styles/ContactPage.module.css';
import videoBackground from '../styles/background.mp4';

const ContactPage = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.contactPageContainer}>
       <video className={styles.contactPageVideoBackground} autoPlay loop muted>
              <source src={videoBackground} type="video/mp4" />
              Your browser does not support the video tag.
       </video>

      <header className={styles.contactPageHeaderMenu}>
        <div onClick={() => navigate('/')} className={styles.contactPagelogo}>
          Full Trucking Service
        </div>
        <nav>
          <ul>
            <li onClick={() => navigate('/about')}>About Us</li>
            <li onClick={() => navigate('/services')}>Services</li>
            <li onClick={() => navigate('/contact')}>Contact</li>
            <li onClick={() => navigate('/pricing')}>Register</li>
          </ul>
        </nav>
      </header>

      {/* 🔥 Fix: Adăugăm un spacer sub header pentru a evita suprapunerea */}
      <div className={styles.contactPageSpacer}></div>

      <div className={styles.contactPageContent}>
        <div className={styles.contactFormContainer}>
          <h1>Contact Us</h1>
          <p>Have questions? Need assistance? We’re here to help.</p>
          <form className={styles.contactPageForm}>
            <input type="text" placeholder="Company Name" className={styles.contactPageInput} required />
            <input type="text" placeholder="Your Name" className={styles.contactPageInput} required />
            <input type="tel" placeholder="Phone Number" className={styles.contactPageInput} required />
            <input type="email" placeholder="Your Email" className={styles.contactPageInput} required />
            <textarea placeholder="Your Message" className={styles.contactPageTextarea} required></textarea>
            <button type="submit" className={styles.contactPageButton}>Send Message</button>
          </form>
        </div>
      </div>

       <footer className={styles.contactPageFooter}>
       <p onClick={() => navigate('/terms')} className={styles.contactPagefooterLink}>
         Terms of Service
       </p>
       <p onClick={() => navigate('/privacy')} className={styles.contactPagefooterLink}>
         Privacy Policy
       </p>
       <p onClick={() => navigate('/help')} className={styles.contactPagefooterLink}>
         Help
       </p>
      </footer>
    </div>
  );
};

export default ContactPage;
